import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms/forms';
import { of, fromEvent, Observable, Subject } from "rxjs";
import { debounceTime, map, distinctUntilChanged, switchMap, tap, takeUntil, min } from "rxjs/operators";
import { IWord } from 'src/app/models/word-ref.model';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent {

  @ViewChild('dictionarySearchInput') dictionarySearchInput: ElementRef;
  @Output() setcarNameEvent = new EventEmitter<{ name: string }>();

  searchTextUpdate = new Subject<string>();


  showSearches: boolean = false;
  isSearching: boolean = false;
  searchText: string = '';


  @Input() searchedItems: IWord[];
  @Input() placeholder: string;

  @Output() onSearch: EventEmitter<string> = new EventEmitter();
  @Output() onSelectWord: EventEmitter<string> = new EventEmitter();

  constructor() {

    this.searchTextUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        this.isSearching = value != "";
        if (value == '') {
          this.searchedItems = [];
        }
        if (value.length < 2) {
          this.searchedItems = [];
          return
        }
        this.onSearch.emit(value);
      });
  }


  ngAfterViewInit(): void {
    document.addEventListener('click', this.handleClickOutside);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleClickOutside);
  }

  private handleClickOutside = (event: MouseEvent): void => {
    console.log('Touch outside');
    if (!this.dictionarySearchInput.nativeElement.contains(event.target)) {
      this.clearSearch();
    }
  };


  // getCars(name): Observable<any> {
  //   return of(this.filterCars(name))
  // }

  // filterCars(name) {
  //   return this.items.filter((val) => val.toLowerCase().includes(name.toLowerCase()) == true)
  // }

  // carSearch() {
  //   const search$ = fromEvent(this.dictionarySearchInput.nativeElement, 'keyup').pipe(
  //     map((event: any) => event.target.value),
  //     debounceTime(500),
  //     distinctUntilChanged(),
  //     tap(() => this.isSearching = true),
  //     switchMap((term) => term ? this.getCars(term) : of<any>(this.items)),
  //     tap(() => {
  //       this.isSearching = false,
  //         this.showSearches = true;
  //     }));

  //   search$.subscribe(data => {
  //     console.log(data);
  //     this.isSearching = false
  //     this.searchedItems = data;
  //   })
  // }

  // setCarName(name) {
  //   this.searchedItems = this.filterCars(name);
  //   this.setcarNameEvent.emit({ name });
  //   this.dictionarySearchInput.nativeElement.value = name;
  //   this.showSearches = false;
  // }

  // trackById(index, item): void {
  //   return item._id;
  // }

  closeDropDown(): void {
    this.showSearches = false;
  }

  clearSearch() {
    this.searchText = '';
    this.isSearching = false;
  }

  handleShowSearch() {
    return this.searchText;
  }

  onChooseWord(id: string) {
    this.onSelectWord.emit(id);
  }

}
